export default __webpack_public_path__ + "static/media/card-6.1d2d1ecd.png";